import { render, staticRenderFns } from "./coda-lines.vue?vue&type=template&id=aff35a64&scoped=true&"
import script from "./coda-lines.ts?vue&type=script&lang=ts&"
export * from "./coda-lines.ts?vue&type=script&lang=ts&"
import style0 from "./coda-lines.scss?vue&type=style&index=0&id=aff35a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff35a64",
  null
  
)

export default component.exports